import React from 'react';
import { CoverageEntry } from '@Types/riskCoverage.types';
import { ScoreSetupHeader } from './ScoreSetupHeader';
import { ScoreFooter } from './ScoreFooter';

interface PanelProps {
	enabled: boolean;
	coverageEntry?: CoverageEntry;
	coverageEligible: boolean;
}

export const ScoreGuidanceHeader = ({
	enabled,
	coverageEntry,
	coverageEligible,
	componentLabel,
	fieldName,
}: PanelProps & { componentLabel: string; fieldName?: string }) => {
	if (!enabled) return null;
	return (
		<ScoreSetupHeader
			componentLabel={componentLabel}
			fieldName={fieldName}
			coveragePct={coverageEntry?.pct ?? undefined}
			totalAssets={coverageEntry?.assets}
			coverageEligible={coverageEligible}
		/>
	);
};

export const ScoreGuidanceFooter = ({
	enabled,
	coverageEntry,
	coverageEligible,
}: PanelProps) => {
	if (!enabled) return null;
	// pct null = not yet computable, not 0% coverage
	const noDataPct =
		coverageEntry?.pct == null
			? undefined
			: Math.round((1 - coverageEntry.pct / 100) * 1000) / 10;
	return (
		<ScoreFooter
			noDataPct={noDataPct}
			countsLoaded={coverageEntry !== undefined}
			coverageEligible={coverageEligible}
		/>
	);
};
